export default __webpack_public_path__ + "static/media/Path2256.881c29ff.svg";